/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import DateFnsUtils from "@date-io/date-fns";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import { db } from "../Firebase/firebase.js";
import ls from "local-storage";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import moment from "moment";
import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";

const useStyles = makeStyles(styles);
export default function Event() {
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  /////////Other hooks//////////
  //Seach
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  //View
  const [viewflag, setviewflag] = React.useState(false);
  ////////Handling data change////////
  const [editDocID, setEditDocID] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [eventName, setEventName] = React.useState("");
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [startTime, setStartTime] = React.useState(new Date());
  const [endTime, setEndTime] = React.useState(new Date());
  const [location, setLocation] = React.useState("");
  const [status, setStatus] = React.useState("");

  const handleNameChange = (name) => {
    setEventName(name.target.value);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleStartTimeChange = (time) => {
    setStartTime(time);
  };

  const handleEndTimeChange = (time) => {
    setEndTime(time);
  };

  const handleLocationChange = (locationn) => {
    setLocation(locationn.target.value);
  };

  const handleStatusChange = (statuss) => {
    setStatus(statuss.target.value);
  };

  //Handling Add Event dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setEventName("");
    setStartDate(new Date());
    setEndDate(new Date());
    setStartTime(new Date());
    setEndTime(new Date());
    setLocation("");
    setStatus("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //Handling View/Update Dialog
  const [openViewDialog, setViewDialog] = React.useState(false);

  const handleViewClickOpen = () => {
    setViewDialog(true);
  };
  const handleViewArrowClose = () => {
    setViewDialog(false);
  };

  const handleViewClose = () => {
    if (viewflag === true) {
      setViewDialog(false);
    } else {
      UpdateEvent();
    }
  };

  //Handling Delete
  const [opendeletebox, setopendeletebox] = React.useState(false);
  const [deleteDocID, setDeleteDocID] = React.useState(false);

  const openconfirmationbox = () => {
    setopendeletebox(true);
  };
  const closeconfirmationbox = () => {
    setopendeletebox(false);
  };
  const deleteDialog = (row) => {
    setDeleteDocID(row.eventId);
    setopendeletebox(true);
  };

  ///////////////CRUD/////////////////
  //Add event function
  const AddEventToDB = () => {
    db.collection("events")
      .add({
        name: eventName,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
        startTime: moment(startTime).format("HH:MM"),
        endTime: moment(endTime).format("HH:MM"),
        location: location,
        status: status,
      })
      .then((doc) => {
        db.collection("events").doc(doc.id).set(
          {
            eventId: doc.id,
          },
          { merge: true }
        );
        setOpen(false);
        GetEvents();
      })
      .catch((error) => {
        alert(error);
      });
  };

  //Get events function
  const GetEvents = () => {
    let newArray = [];
    db.collection("events")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRows(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      GetEvents();
    }
  }, []);

  //Delete event function
  const DeleteEvent = () => {
    db.collection("events")
      .doc(deleteDocID)
      .delete()
      .then(() => {
        alert("Deleted");
        setopendeletebox(false);
        GetEvents();
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  //Update Event
  const UpdateEvent = () => {
    db.collection("events")
      .doc(editDocID)
      .set(
        {
          name: eventName,
          startDate: moment(startDate).format("YYYY-MM-DD"),
          endDate: moment(endDate).format("YYYY-MM-DD"),
          startTime: moment(startTime).format("HH:MM"),
          endTime: moment(endTime).format("HH:MM"),
          location: location,
          status: status,
        },
        { merge: true }
      )
      .then(() => {
        alert("Event Updated.");
        setViewDialog(false);
        setTimeout(() => {
          GetEvents();
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /////////////Other operations////////////////
  //Search event
  const searchFisherman = () => {
    if (searchflag === true) {
      let newArray = [];
      db.collection("events")
        .where("name", ">=", searchref.current.value)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            newArray.push(doc.data());
          });
          setRows(newArray);
          setsearchflag(false);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    } else {
      searchref.current.value = "";
      GetEvents();
      setsearchflag(true);
    }
  };

  //View Event
  const viewEvent = (row) => {
    setviewflag(true);
    setEventName(row.name);
    setStartDate(row.startDate);
    setEndDate(row.endDate);
    setStartTime(row.startTime);
    setEndTime(row.endTime);
    setLocation(row.location);
    setStatus(row.status);
    setViewDialog(true);
  };

  //Update Event
  const updateEventDialog = (row) => {
    setviewflag(false);
    setEditDocID(row.eventId);
    setEventName(row.name);
    setStartDate(row.startDate);
    setEndDate(row.endDate);
    setStartTime(row.startTime);
    setEndTime(row.endTime);
    setLocation(row.location);
    setStatus(row.status);
    setViewDialog(true);
  };

  /////////Styling////////
  const classes = useStyles();

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "500px" : "80px" }}>
            <TextField
              placeholder="Search"
              variant="outlined"
              inputRef={searchref}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={searchFisherman}>
                      {searchflag ? <SearchIcon /> : <ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </GridItem>
      </GridContainer>
      <br></br>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{
              height: 450,
              overflowY: "scroll",
              overflowX: "auto",
              display: "inline-block",
            }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: "20%" }}
                    className={[classes.tableheadercell, classes.tablehead]}
                  >
                    ID
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                    style={{ width: "15%" }}
                  >
                    Event Name
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                  >
                    Location
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                  >
                    Status
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                    style={{ width: "15%" }}
                  >
                    Start Date
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                    style={{ width: "15%" }}
                  >
                    End Date
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                  >
                    Starting Time
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                  >
                    Closing Time
                  </TableCell>
                  <TableCell
                    className={[classes.tableheadercell, classes.tablehead]}
                    align="left"
                    style={{ width: "15%" }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.eventId}>
                    <TableCell
                      onClick={() => viewEvent(row)}
                      style={{ color: "blue" }}
                      component="th"
                      scope="row"
                    >
                      {row.eventId}
                    </TableCell>

                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.location}</TableCell>
                    <TableCell align="left">{row.status}</TableCell>
                    <TableCell align="left">{row.startDate}</TableCell>
                    <TableCell align="left">{row.endDate}</TableCell>
                    <TableCell align="left">{row.startTime}</TableCell>
                    <TableCell align="left">{row.endTime}</TableCell>
                    <TableCell align="left">
                      <div>
                        <IconButton onClick={() => deleteDialog(row)}>
                          <DeleteForeverIcon
                            style={{ color: "red", width: "15" }}
                          />
                        </IconButton>
                        <IconButton onClick={() => updateEventDialog(row)}>
                          <EditIcon style={{ color: "green", width: "15" }} />
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <br></br>
          <Button
            onClick={handleClickOpen}
            style={{ backgroundColor: "#171942" }}
          >
            Add Event
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Add Event</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 500, width: 600 }}>
              <div className="event-form">
                <TextField
                  required
                  id="event_name"
                  label="Event Name"
                  variant="outlined"
                  onChange={handleNameChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                {mobileratio ? null : <br></br>}
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="start-date-picker"
                    label="Start Date"
                    inputVariant="outlined"
                    mask="__/__/____"
                    value={startDate}
                    onChange={handleStartDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    required
                    style={{ marginRight: 10 }}
                  />
                  {/* {mobileratio? <br></br>:null} */}
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="end-date-picker"
                    label="End Date"
                    inputVariant="outlined"
                    value={endDate}
                    onChange={handleEndDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    style={{ display: mobileratio ? "block" : null }}
                    required
                  />
                </MuiPickersUtilsProvider>
                {mobileratio ? null : <br></br>}
                {mobileratio ? null : <br></br>}
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    margin="normal"
                    id="start-time-picker"
                    label="Starting Time"
                    inputVariant="outlined"
                    value={startTime}
                    onChange={handleStartTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "change time",
                    }}
                    required
                    style={{ marginRight: 10 }}
                  />
                  {/* {mobileratio? <br></br>:null} */}
                  <KeyboardTimePicker
                    margin="normal"
                    id="end-time-picker"
                    label="Closing Time "
                    inputVariant="outlined"
                    value={endTime}
                    onChange={handleEndTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "change time",
                    }}
                    style={{ display: mobileratio ? "block" : null }}
                    required
                  />
                </MuiPickersUtilsProvider>
                <br></br>
                {mobileratio ? null : <br></br>}
                <div>
                  <TextField
                    required
                    label="Location"
                    variant="outlined"
                    onChange={handleLocationChange}
                    style={{ marginRight: 10, width: 267 }}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ width: 267 }}
                    required
                  >
                    <InputLabel id="status_label">Status</InputLabel>
                    <Select
                      labelId="event_status"
                      id="status"
                      value={status}
                      onChange={handleStatusChange}
                      label="Status"
                    >
                      <MenuItem value={"Open"}>Open</MenuItem>
                      <MenuItem value={"Closed"}>Closed</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 560,
                  backgroundColor: "#171942",
                }}
                onClick={AddEventToDB}
                autoFocus
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* View/Update Dialog */}
          <Dialog
            open={openViewDialog}
            onClose={handleViewArrowClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleViewArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 500, width: 600 }}>
              <div className="event-form">
                <TextField
                  required
                  id="event_name"
                  label="Event Name"
                  value={viewflag ? eventName : null}
                  defaultValue={viewflag ? null : eventName}
                  variant="outlined"
                  onChange={handleNameChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
                <br></br>
                {mobileratio ? null : <br></br>}
                {viewflag ? (
                  <div>
                    <TextField
                      value={startDate}
                      required
                      label="Start Date"
                      variant="outlined"
                      style={{ width: mobileratio ? 267 : 540 }}
                    />
                    <br></br>
                    <TextField
                      value={endDate}
                      required
                      label="End Date"
                      variant="outlined"
                      style={{ width: mobileratio ? 267 : 540 }}
                    />
                  </div>
                ) : (
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MM/dd/yyyy"
                      margin="normal"
                      id="start-date-picker"
                      label="Start Date"
                      inputVariant="outlined"
                      mask="__/__/____"
                      value={startDate}
                      onChange={handleStartDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      required
                      style={{ marginRight: 10 }}
                    />
                    {/* {mobileratio? <br></br>:null} */}
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MM/dd/yyyy"
                      margin="normal"
                      id="end-date-picker"
                      label="End Date"
                      inputVariant="outlined"
                      value={endDate}
                      onChange={handleEndDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ display: mobileratio ? "block" : null }}
                      required
                    />
                  </MuiPickersUtilsProvider>
                )}
                {mobileratio ? null : <br></br>}
                {mobileratio ? null : <br></br>}
                {viewflag ? (
                  <div>
                    <TextField
                      value={startTime}
                      required
                      label="Start Time"
                      variant="outlined"
                      style={{ width: mobileratio ? 267 : 540 }}
                    />
                    <br></br>
                    <TextField
                      value={endTime}
                      required
                      label="End Time"
                      variant="outlined"
                      style={{ width: mobileratio ? 267 : 540 }}
                    />
                  </div>
                ) : (
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardTimePicker
                      margin="normal"
                      id="start-time-picker"
                      label="Starting Time"
                      inputVariant="outlined"
                      value={startTime}
                      onChange={handleStartTimeChange}
                      KeyboardButtonProps={{
                        "aria-label": "change time",
                      }}
                      required
                      style={{ marginRight: 10 }}
                    />
                    {/* {mobileratio? <br></br>:null} */}
                    <KeyboardTimePicker
                      margin="normal"
                      id="end-time-picker"
                      label="Closing Time "
                      inputVariant="outlined"
                      value={endTime}
                      onChange={handleEndTimeChange}
                      KeyboardButtonProps={{
                        "aria-label": "change time",
                      }}
                      style={{ display: mobileratio ? "block" : null }}
                      required
                    />
                  </MuiPickersUtilsProvider>
                )}
                <br></br>
                {mobileratio ? null : <br></br>}
                <div>
                  <TextField
                    required
                    label="Location"
                    variant="outlined"
                    value={viewflag ? location : null}
                    defaultValue={viewflag ? null : location}
                    onChange={handleLocationChange}
                    style={{ marginRight: 10, width: 267 }}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  {viewflag ? (
                    <TextField
                      value={status}
                      required
                      label="Status"
                      variant="outlined"
                      style={{ width: 265, marginRight: 10 }}
                    />
                  ) : (
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: 267 }}
                      required
                    >
                      <InputLabel id="status_label">Status</InputLabel>
                      <Select
                        labelId="event_status"
                        id="status"
                        value={status}
                        onChange={handleStatusChange}
                        label="Status"
                      >
                        <MenuItem value={"Open"}>Open</MenuItem>
                        <MenuItem value={"Closed"}>Closed</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 560,
                  backgroundColor: "#171942",
                }}
                onClick={handleViewClose}
                autoFocus
              >
                {viewflag ? "Close" : "Update"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* confirmation box */}
          <Dialog
            open={opendeletebox}
            onClose={closeconfirmationbox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Are you sure you want to delete this event?
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions>
              <Button onClick={DeleteEvent} color="primary">
                Yes
              </Button>
              <Button onClick={closeconfirmationbox} color="primary">
                No
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    </>
  );
}
